import { useEffect, useState } from "react";
import api from "@/lib/api";
import SocialProofToast from "@/components/SocialProofToast";

export default function SocialProofGlobal() {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);
  return <SocialProofToast products={products} />;
}
